import { Col, Form, Row } from 'antd';
import { useCallback, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getCargoSpecificShipmentAccessorialsInProgress } from '../../../../../../redux/shipment/ShipmentActions';
import { trimObjectValues } from '../../../../../../utilz';
import { routeFileSelector } from '../../../../../../utilz/i18n';
import FormDatePicker from '../../../../../components/Inputs/FormDatePicker';
import { CargoTypeSelect, ShipmentBranchSelect, ShipmentTermsSelect, ShipmentTypeSelect } from '../../selects';

const TransportationProviderSearchForm = () => {
  const dispatch = useDispatch();
  const { selectedCompany } = useSelector((state) => state.auth);
  const { tmsSettings } = useSelector((state) => state.settings);
  const [form] = Form.useForm();
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  useEffect(() => {
    if (tmsSettings?.data?.shipmentSettings) {
      form.setFieldsValue({
        branch: tmsSettings?.data?.shipmentSettings?.defaultBranchKey,
        shipmentType: tmsSettings?.data?.shipmentSettings?.defaultShipmentType,
        shipmentTerms: tmsSettings?.data?.shipmentSettings?.defaultShipmentTerms,
      });
    }
  }, [form, tmsSettings?.data?.shipmentSettings]);

  const cargoType = Form.useWatch('cargoType', form);

  const fetchCargoSpecificAccessorials = useCallback(() => {
    if (cargoType) {
      const payload = {
        shipmentKey: 0,
        cargoType: cargoType.join(','),
      };
      dispatch(getCargoSpecificShipmentAccessorialsInProgress(payload));
    }
  }, [cargoType, dispatch]);

  useEffect(() => {
    fetchCargoSpecificAccessorials();
  }, [cargoType, fetchCargoSpecificAccessorials]);

  return (
    <>
      <Form
        form={form}
        name="transportationProviderSearchForm"
        initialValues={trimObjectValues({
          branch: tmsSettings?.data?.shipmentSettings?.defaultBranchKey,
          shipmentType: tmsSettings?.data?.shipmentSettings?.defaultShipmentType,
          shipmentTerms: tmsSettings?.data?.shipmentSettings?.defaultShipmentTerms,
          cargoType: [],
        })}
      >
        <Row gutter={30}>
          <Col className="w-20">
            <ShipmentTypeSelect
              name="shipmentType"
              margin="mb-12"
              rules={[
                {
                  required: true,
                  message: t('translation:default.fields.shipmentType.label'),
                },
              ]}
            />
            <CargoTypeSelect
              label={t('translation:default.fields.cargoType.label')}
              placeholder={t('translation:default.fields.cargoType.placeholder')}
              name="cargoType"
              mode="multiple"
              disableDefaultOptions
            />
          </Col>
          <Col className="w-20">
            <FormDatePicker
              name="shipDate"
              label={t('translation:default.fields.shipDate.label')}
              margin="m-0"
              rules={[
                {
                  required: true,
                  message: t('translation:default.fields.shipDate.message'),
                },
              ]}
            />
          </Col>
          <Col className="w-20">
            <FormDatePicker
              name="deliveryDate"
              label={t('translation:default.fields.deliveryDate.label')}
              margin="m-0"
              rules={[
                {
                  required: true,
                  message: t('translation:default.fields.deliveryDate.message'),
                },
              ]}
            />
          </Col>
          <Col className="w-20">
            <ShipmentTermsSelect
              name="shipmentTerms"
              margin="m-0"
              rules={[
                {
                  required: true,
                  message: t('translation:default.fields.shipmentTerms.message'),
                },
              ]}
            />
          </Col>
          <Col className="w-20">
            <ShipmentBranchSelect
              name="branch"
              margin="m-0"
              customerId={selectedCompany?.companyId}
              rules={[
                {
                  required: true,
                  message: t('translation:default.fields.shipmentBranch.message'),
                },
              ]}
            />
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default TransportationProviderSearchForm;
